import $api from "../http";
import { IUserSubscriptionModel } from "../models/UserSubscription";
import { IModelForBuyingSubscription, IModelForChangingSubscription } from "../models/Subscription";

class UserSubscriptionServiceClass {
  async getUserSubscriptionByUserId(userId: string | null) {
    return await $api.get<IUserSubscriptionModel | null>(
      `api/user-subscriptions/get-by-userId/${userId}`
    );
  }

  async buySubscription(model: IModelForBuyingSubscription) {
    return await $api.post<boolean>(`api/user-subscriptions/buy`, model);
  }

  async changeSubscription(model: IModelForChangingSubscription) {
    return await $api.post<boolean>(`api/user-subscriptions/change`, model);
  }

  async cancelSubscription(id: string) {
    return await $api.delete<boolean>(`api/user-subscriptions/cancel/${id}`);
  }
}

export const UserSubscriptionService = new UserSubscriptionServiceClass();
